export enum Source {
	Conversion = 1,
	MealsPlus = 2,
	SummerPay = 4,
}
